import { isNil } from 'lodash-es';
import { Store } from '@betgames/bg-state-manager';
import { StorageRepository } from '@betgames/bg-tools';
import { PersistKey } from 'providers/Persist';
import { IAppFeatures } from 'src/store/AppFeatures/interfaces';
import AppFeaturesRepository from './AppFeatures.repository';

export default class AppFeaturesStore extends Store<IAppFeatures> {
    private persistState = (): void => {
        this.persistor.setItemParsed(PersistKey.featureToggle, this.value);
    };

    constructor(
        private readonly persistor: StorageRepository,
        private readonly repository: AppFeaturesRepository,
    ) {
        super({
            key: 'AppFeatures',
            default: {
                partnerName: '',
                quickBetEnabled: true,
                htpOnScreenEnabled: true,
                tutorialEnabled: true,
            },
        });

        const persistedState = this.persistor.getItemParsed<IAppFeatures>(PersistKey.featureToggle);

        if (persistedState) {
            this.update((draft) => {
                if (!isNil(persistedState.quickBetEnabled)) {
                    draft.quickBetEnabled = persistedState.quickBetEnabled;
                }

                if (!isNil(persistedState.htpOnScreenEnabled)) {
                    draft.htpOnScreenEnabled = persistedState.htpOnScreenEnabled;
                }

                if (!isNil(persistedState.tutorialEnabled)) {
                    draft.tutorialEnabled = persistedState.tutorialEnabled;
                }
            });
        }
    }

    public setQuickBetEnabled(enabled: boolean) {
        this.update((draft) => {
            draft.quickBetEnabled = enabled;
        });

        this.persistState();
    }

    public setHtpOnScreenEnabled(enabled: boolean) {
        this.update((draft) => {
            draft.htpOnScreenEnabled = enabled;
        });

        this.persistState();
    }

    public setTutorialEnabled(enabled: boolean) {
        this.update((draft) => {
            draft.tutorialEnabled = enabled;
        });

        this.persistState();
    }

    public initFeaturesByPartner(partnerCode: string) {
        this.repository.fetchPartnerFeatures(partnerCode).then((response) => {
            this.update((draft) => {
                draft.htpOnScreenEnabled = response.htpOnScreenEnabled ?? draft.htpOnScreenEnabled;
                draft.quickBetEnabled = response.quickBetEnabled ?? draft.quickBetEnabled;
                draft.tutorialEnabled = response.tutorialEnabled ?? draft.tutorialEnabled;
                draft.partnerName = response.partnerName ?? draft.partnerName;
            });

            this.persistState();
        });
    }
}
